<script setup lang="ts">
defineEmits(['close', 'confirm', 'update:isOpen'])
defineOptions({ inheritAttrs: false })

const props = defineProps<{
  isOpen?: boolean
  color?: 'success' | 'error' | 'alert' | 'green'
  text?: string
  title?: string
  icon?: string
  rounded?: string
}>()
</script>

<template>
  <v-dialog :model-value="props.isOpen" persistent max-width="500px">
    <v-card
      class="text-center"
      color="white"
      elevation="2"
      style="padding: 16px"
      :style="{ borderRadius: rounded ? rounded : '' }"
    >
      <v-card-title class="text-center">
        <span class="text-h5 font-weight-bold" style="margin-top: 8px">
          {{ title }}
        </span>
      </v-card-title>

      <v-card-text v-if="text">
        <div v-html="text" />
      </v-card-text>

      <!-- Conteúdo passado pelo pai -->
      <slot />
    </v-card>
  </v-dialog>
</template>
